import { useState, useEffect } from "react";
import { Box, Typography, Button, useTheme, Paper } from "@mui/material";
import { useTranslation } from "react-i18next";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation();

  useEffect(() => {
    const seen = localStorage.getItem("cookie_notice_seen");
    if (!seen) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("cookie_notice_seen", "true");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Paper
      elevation={6}
      sx={{
        position: "fixed",
        bottom: { xs: "0vw", md: "4vw" },
        left: { xs: "0vw", md: "4vw" },
        maxWidth: { xs: "100vw", md: "28vw" },
        p: 3,
        bgcolor: theme.palette.primary.main,
        color: theme.palette.common.white,
        border: "none",
        borderRadius: { xs: "0px", md: "6px" },
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        zIndex: 9999,
      }}
    >
      <Typography variant="body2">
        {t("general.cookies_banner_copy")}{" "}
        <a
          href="/privatums"
          style={{ color: "inherit", textDecoration: "underline" }}
        >
          {t("general.cookies_banner_cta")}
        </a>
      </Typography>
      <Box display="flex" justifyContent="flex-end">
        <Button
          size="small"
          variant="outlined"
          fullWidth
          onClick={accept}
          sx={{
            color: theme.palette.primary.main,
            bgcolor: theme.palette.primary.superlight2,
            border: `1px solid ${theme.palette.primary.superlight2}`,
            "&:hover": {
              bgcolor: theme.palette.common.white,
              color: theme.palette.primary.main,
              border: `1px solid ${theme.palette.common.white}`,
            },
          }}
        >
          OK
        </Button>
      </Box>
    </Paper>
  );
}
